export const LOAD_POPULAR_MOVIES = "LOAD_POPULAR_MOVIES";
export const LOAD_POPULAR_MOVIES_SUCCESS = "LOAD_POPULAR_MOVIES_SUCCESS";
export const LOAD_POPULAR_MOVIES_ERROR = "LOAD_POPULAR_MOVIES_ERROR";

export const LOAD_MOVIE_DETAILS = "LOAD_MOVIE_DETAILS";
export const LOAD_MOVIE_DETAILS_SUCCESS = "LOAD_MOVIE_DETAILS_SUCCESS";
export const LOAD_MOVIE_DETAILS_ERROR = "LOAD_MOVIE_DETAILS_ERROR";

export const SEARCH_MOVIE = "SEARCH_MOVIE";
export const SEARCH_MOVIE_SUCCESS = "SEARCH_MOVIE_SUCCESS";
export const SEARCH_MOVIE_ERROR = "SEARCH_MOVIE_ERROR";



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/